'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const listBoxItem = "_list-box-item_1kwcn_1";
const styles = {
	listBoxItem: listBoxItem
};

const TypeaheadItem = (_a) => {
  var { children, className, id, size = "large", textValue } = _a, props = tslib_es6.__rest(_a, ["children", "className", "id", "size", "textValue"]);
  const childrenIsPureText = React__default.default.useMemo(() => React__default.default.Children.toArray(children).every((child) => typeof child === "string" || typeof child === "number"), [children]);
  if (!childrenIsPureText && !textValue) {
    console.error("Typeahead.Item: The `textValue` prop must be set if `children` is not plain text.");
  }
  return React__default.default.createElement(reactAriaComponents.ListBoxItem, Object.assign({ className: clsx.clsx(className, styles.listBoxItem), "data-size": size, "data-zds": true, id, textValue }, props), children);
};

exports.TypeaheadItem = TypeaheadItem;
//# sourceMappingURL=TypeaheadItem.cjs.js.map
